class Form {

    formSelector = "#_form-24";

    constructor() {
        this.init();
    }

    init = () => {
        window.addEventListener("DOMContentLoaded", () => {

            const form = document.querySelector(this.formSelector);

            if (form) {

                form.addEventListener("click", (eve) => {
                    // inc
                    if (eve.target.offsetParent && eve.target.offsetParent.classList.contains("inc")) {
                        this.incProduct(eve, form);
                    }
                    // dec
                    if (eve.target.offsetParent && eve.target.offsetParent.classList.contains("dec")) {
                        this.decProduct(eve, form);
                    }
                    // submit
                    if(eve.target.id == "_cart-pay") {
                        eve.preventDefault();
                        // if (!this.validation(eve, form)) {
                        //     return;
                        // }
                        form.submit();
                    }
                });
            }
        });
    }

    incProduct = (eve, form) => {
        let qtyInput = eve.target.closest('.td-quantity').querySelector('.cart__quantity-selector');
        let oldVal = qtyInput.value;
        let newVal = parseInt(oldVal) + 1;
        qtyInput.value = newVal;
        form.action = "/cart"
        form.submit();
    }

    decProduct = (eve, form) => {
        let qtyInput = eve.target.closest('.td-quantity').querySelector('.cart__quantity-selector');
        let oldVal = qtyInput.value;
        let newVal = parseInt(oldVal) - 1;
        if (newVal < 1) newVal = 1;
        qtyInput.value = newVal;
        form.action = "/cart"
        form.submit();
    }

    validation = (eve, form) => {
        let containerApp = document.querySelector('.container-app'); // container Delivery & Pickup https://apps.shopify.com/order-delivery-date-by-identixweb
        let communes = form.querySelector("#_communes");
        let select = communes.getElementsByTagName('select')[0];

        let notyf = new window.Notyf({
            position: {
                x: 'center',
                y: 'top',
            },
        });

        if (select.value.trim() === "") { // validate input communa
            notyf.error('Debes Seleccionar una comuna de despacho');
            return false;
        }

        if (containerApp.dataset.calendarDelivery == 'true') { // validamos si el selector container del plugin tiene el data set configurado en "cake-calendar-cart_24.js"
            let inputDate = document.querySelector('input.oddCalanderOffset');
            let inputTime = document.querySelector('input.deliverytimeValues');

            if (inputDate.value == "") { // validamos input date del plugin
                notyf.error('Debes Seleccionar una fecha despacho.');
                return false;
            }

            if (inputTime.value == "") { // validamos input time del plugin
                notyf.error('Debes Seleccionar una hora de despacho.');
                return false;
            }
        }
        return true;
    }
}

new Form(); // iniciamos formulario